

export default class BackgroundMixTranslations  {
	Id: number = 0;
	LangCode?: string = '';
	Name?: string = '';
	Description?: string = '';
	constructor(obj?: Partial<BackgroundMixTranslations>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
